import React from "react";
import { Paper, Text } from "@mantine/core";
import {
  LeafletControlWrapper,
  LeafletControlWrapperProps,
} from "components/LeafletMap/Utils/LeafletControlWrapper";
import { MouseCoordinateValueDisplay } from "./MouseCoordinateValueDisplay";

type Props = {
  position: LeafletControlWrapperProps["position"];
};
/**
 * Displays current mouse position coordinates
 */
export const MouseCoordinateControl = ({ position }: Props) => (
  <LeafletControlWrapper position={position}>
    <Paper
      sx={(_, u) => ({
        [u.dark]: {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
        [u.light]: {
          backgroundColor: "rgba(255,255,255,.8)",
        },
        cursor: "pointer",
      })}
    >
      <Text size="xs" py={3} px={4} mr={4}>
        <MouseCoordinateValueDisplay />
      </Text>
    </Paper>
  </LeafletControlWrapper>
);
